import { useRouter } from 'next/router'

export default function useLocale() {
  const router = useRouter()
  const locale = process.env.STORYBOOK ? 'it' : router.locale
  const locales = process.env.STORYBOOK ? ['it', 'en', 'de', 'fra', 'esp'] : router.locales
  const langMap = {
    us: 'en',
    fra:'fr',
    esp: 'es',
  }
  const isAmericaLang = (l) => ['us', 'fr', 'es'].includes(l)
  const isAmerica = isAmericaLang(locale)
  const clusterLangs = locales.filter((l) => isAmerica === isAmericaLang(l))
  return {
    isAmerica: isAmerica,
    lang: langMap[locale] || locale, // Lingua corrente
    clusterLangs: clusterLangs, // Le lingue del cluster America/non-America corrente
  }
}
